export const QUOTES_CONFIG = {
  cableDiameter: {
    wireDiameter: 0.075,
    conductorQuantity: null,
    answer: null,
    factor: null,
    layUp: null,
    showPopup: false,
    specs: {
      3: {
        conductors: '3/C',
        factor: 2.15,
        layUp: '-',
      },
      4: {
        conductors: '4/C',
        factor: 2.415,
        layUp: '-',
      },
      5: {
        conductors: '5/C',
        factor: 2.7,
        layUp: 'F-5',
      },
      6: {
        conductors: '6/C',
        factor: 3,
        layUp: 'F-6',
      },
      7: {
        conductors: '7/C',
        factor: 3,
        layUp: '1-6',
      },
      8: {
        conductors: '8/C',
        factor: 3.3,
        layUp: '(1+F)-7',
      },
      9: {
        conductors: '9/C',
        factor: 4,
        layUp: '2-(7+F)',
      },
      10: {
        conductors: '10/C',
        factor: 4,
        layUp: '2-8',
      },
      11: {
        conductors: '11/C',
        factor: 4.15,
        layUp: '3-(8+F)',
      },
      12: {
        conductors: '12/C',
        factor: 4.15,
        layUp: '3-9',
      },
      13: {
        conductors: '13/C',
        factor: 4.415,
        layUp: '4-(9+F)',
      },
      14: {
        conductors: '14/C',
        factor: 4.415,
        layUp: '4-10',
      },
      15: {
        conductors: '15/C',
        factor: 4.7,
        layUp: 'F-5-(10+F)',
      },
      16: {
        conductors: '16/C',
        factor: 4.7,
        layUp: 'F-5-11',
      },
      17: {
        conductors: '17/C',
        factor: 5,
        layUp: '1-6-(10+2F)',
      },
      18: {
        conductors: '18/C',
        factor: 5,
        layUp: '1-6-(11+1F)',
      },
      19: {
        conductors: '19/C',
        factor: 5,
        layUp: '1-6-12',
      },
      20: {
        conductors: '20/C',
        factor: 5.3,
        layUp: 'F-7-13',
      },
      21: {
        conductors: '21/C',
        factor: 5.3,
        layUp: '(1+F)-7-13',
      },
      22: {
        conductors: '22/C',
        factor: 6,
        layUp: '2-8-(12+2F)',
      },
      23: {
        conductors: '23/C',
        factor: 6,
        layUp: '2-8-(13+1F)',
      },
      24: {
        conductors: '24/C',
        factor: 6,
        layUp: '2-8-14',
      },
      25: {
        conductors: '25/C',
        factor: 6.15,
        layUp: '3-9-(13+2F)',
      },
      26: {
        conductors: '26/C',
        factor: 6.15,
        layUp: '3-9-(14+1F)',
      },
      27: {
        conductors: '27/C',
        factor: 6.15,
        layUp: '3-9-15',
      },
      28: {
        conductors: '28/C',
        factor: 6.415,
        layUp: '4-10-(14+2F)',
      },
      29: {
        conductors: '29/C',
        factor: 6.415,
        layUp: '4-10-(15+1F)',
      },
      30: {
        conductors: '30/C',
        factor: 6.415,
        layUp: '4-10-16',
      },
      31: {
        conductors: '31/C',
        factor: 6.7,
        layUp: 'F-5-11-(15+2F)',
      },
      32: {
        conductors: '32/C',
        factor: 6.7,
        layUp: 'F-5-11-(16+1F)',
      },
      33: {
        conductors: '33/C',
        factor: 6.7,
        layUp: 'F-5-11-17',
      },
      34: {
        conductors: '34/C',
        factor: 7,
        layUp: '1-6-12-(15+3F)',
      },
      35: {
        conductors: '35/C',
        factor: 7,
        layUp: '1-6-12-(15+2F)',
      },
      36: {
        conductors: '36/C',
        factor: 7,
        layUp: '1-6-12-(17+1F)',
      },
      37: {
        conductors: '37/C',
        factor: 7,
        layUp: '1-6-12-18',
      },
      38: {
        conductors: '38/C',
        factor: 7.3,
        layUp: '(1+F)-7-13-(17+2F)',
      },
      39: {
        conductors: '39/C',
        factor: 7.3,
        layUp: '(1+F)-7-13-(18+1F)',
      },
      40: {
        conductors: '40/C',
        factor: 7.3,
        layUp: '(1+F)-7-13-19',
      },
      41: {
        conductors: '41/C',
        factor: 8,
        layUp: '2-8-14-(17+3F)',
      },
      42: {
        conductors: '42/C',
        factor: 8,
        layUp: '2-8-14-(18+2F)',
      },
      43: {
        conductors: '43/C',
        factor: 8,
        layUp: '2-8-14-(19+1F)',
      },
      44: {
        conductors: '44/C',
        factor: 8,
        layUp: '2-8-14-20',
      },
      45: {
        conductors: '45/C',
        factor: 8.15,
        layUp: '3-9-15-(18+3F)',
      },
      46: {
        conductors: '46/C',
        factor: 8.15,
        layUp: '3-9-15-(19+2F)',
      },
      47: {
        conductors: '47/C',
        factor: 8.15,
        layUp: '3-9-15-(20+1F)',
      },
      48: {
        conductors: '48/C',
        factor: 8.15,
        layUp: '3-9-15-21',
      },
      49: {
        conductors: '49/C',
        factor: 8.415,
        layUp: '4-10-16-(19+3F)',
      },
      50: {
        conductors: '50/C',
        factor: 8.415,
        layUp: '4-10-16-(20+2F)',
      },
      51: {
        conductors: '51/C',
        factor: 8.415,
        layUp: '4-10-16-(21+1F)',
      },
      52: {
        conductors: '52/C',
        factor: 8.415,
        layUp: '4-10-16-22',
      },
      53: {
        conductors: '53/C',
        factor: 8.7,
        layUp: 'F-5-11-17-(20+3F)',
      },
      54: {
        conductors: '54/C',
        factor: 8.7,
        layUp: 'F-5-11-17-(21+2F)',
      },
      55: {
        conductors: '55/C',
        factor: 8.7,
        layUp: 'F-5-11-17-(22+1F)',
      },
      56: {
        conductors: '56/C',
        factor: 8.7,
        layUp: 'F-5-11-17-23',
      },
      57: {
        conductors: '57/C',
        factor: 9,
        layUp: '1-6-12-18-(20+4F)',
      },
      58: {
        conductors: '58/C',
        factor: 9,
        layUp: '1-6-12-18-(21+3F)',
      },
      59: {
        conductors: '59/C',
        factor: 9,
        layUp: '1-6-12-18-(22+2F)',
      },
      60: {
        conductors: '60/C',
        factor: 9,
        layUp: '1-6-12-18-(23+1F)',
      },
      61: {
        conductors: '61/C',
        factor: 9,
        layUp: '1-6-12-18-24',
      },
      62: {
        conductors: '62/C',
        factor: 9.3,
        layUp: '(1+F)-7-13-19-(22+3F)',
      },
      63: {
        conductors: '63/C',
        factor: 9.3,
        layUp: '(1+F)-7-13-19-(23+2F)',
      },
      64: {
        conductors: '64/C',
        factor: 9.3,
        layUp: '(1+F)-7-13-19-(24+1F)',
      },
      65: {
        conductors: '65/C',
        factor: 9.3,
        layUp: '(1+F)-7-13-19-25',
      },
      66: {
        conductors: '66/C',
        factor: 10,
        layUp: '2-8-14-20-(22+4F)',
      },
      67: {
        conductors: '67/C',
        factor: 10,
        layUp: '2-8-14-20-(23+3F)',
      },
      68: {
        conductors: '68/C',
        factor: 10,
        layUp: '2-8-14-20-(24+2F)',
      },
      69: {
        conductors: '69/C',
        factor: 10,
        layUp: '2-8-14-20-(25+1F)',
      },
      70: {
        conductors: '70/C',
        factor: 10,
        layUp: '2-8-14-20-26',
      },
      71: {
        conductors: '71/C',
        factor: 10.15,
        layUp: '3-9-15-21-(23+4F)',
      },
      72: {
        conductors: '72/C',
        factor: 10.15,
        layUp: '3-9-15-21-(24+3F)',
      },
      73: {
        conductors: '73/C',
        factor: 10.15,
        layUp: '3-9-15-21-(25+2F)',
      },
      74: {
        conductors: '74/C',
        factor: 10.15,
        layUp: '3-9-15-21-(26+1F)',
      },
      75: {
        conductors: '75/C',
        factor: 10.15,
        layUp: '3-9-15-21-27',
      },
      76: {
        conductors: '76/C',
        factor: 10.415,
        layUp: '4-10-16-22-(24+4F)',
      },
      77: {
        conductors: '77/C',
        factor: 10.415,
        layUp: '4-10-16-22-(25+3F)',
      },
      78: {
        conductors: '78/C',
        factor: 10.415,
        layUp: '4-10-16-22-(26+2F)',
      },
      79: {
        conductors: '79/C',
        factor: 10.415,
        layUp: '4-10-16-22-(27+1F)',
      },
      80: {
        conductors: '80/C',
        factor: 10.415,
        layUp: '4-10-16-22-28',
      },
      81: {
        conductors: '81/C',
        factor: 10.7,
        layUp: 'F-5-11-17-23-(25+4F)',
      },
      82: {
        conductors: '82/C',
        factor: 10.7,
        layUp: 'F-5-11-17-23-(26+3F)',
      },
      83: {
        conductors: '83/C',
        factor: 10.7,
        layUp: 'F-5-11-17-23-(27+2F)',
      },
      84: {
        conductors: '84/C',
        factor: 10.7,
        layUp: 'F-5-11-17-23-(28+1F)',
      },
      85: {
        conductors: '85/C',
        factor: 10.7,
        layUp: 'F-5-11-17-23-29',
      },
      86: {
        conductors: '86/C',
        factor: 11,
        layUp: '1-6-12-18-24-(25+5F)',
      },
      87: {
        conductors: '87/C',
        factor: 11,
        layUp: '1-6-12-18-24-(26+4F)',
      },
      88: {
        conductors: '88/C',
        factor: 11,
        layUp: '1-6-12-18-24-(27+3F)',
      },
      89: {
        conductors: '89/C',
        factor: 11,
        layUp: '1-6-12-18-24-(28+2F)',
      },
      90: {
        conductors: '90/C',
        factor: 11,
        layUp: '1-6-12-18-24-(29+1F)',
      },
      91: {
        conductors: '91/C',
        factor: 11,
        layUp: '1-6-12-18-24-30',
      },
      92: {
        conductors: '92/C',
        factor: 11.3,
        layUp: '(1+F)-7-13-19-25-(27+4F)',
      },
      93: {
        conductors: '93/C',
        factor: 11.3,
        layUp: '(1+F)-7-13-19-25-(28+3F)',
      },
      94: {
        conductors: '94/C',
        factor: 11.3,
        layUp: '(1+F)-7-13-19-25-(29+2F)',
      },
      95: {
        conductors: '95/C',
        factor: 11.3,
        layUp: '(1+F)-7-13-19-25-(30+1F)',
      },
      96: {
        conductors: '96/C',
        factor: 11.3,
        layUp: '(1+F)-7-13-19-25-31',
      },
      97: {
        conductors: '97/C',
        factor: 12,
        layUp: '2-8-14-20-26-(27+5F)',
      },
      98: {
        conductors: '98/C',
        factor: 12,
        layUp: '2-8-14-20-26-(28+4F)',
      },
      99: {
        conductors: '99/C',
        factor: 12,
        layUp: '2-8-14-20-26-(29+3F)',
      },
      100: {
        conductors: '100/C',
        factor: 12,
        layUp: '2-8-14-20-26-(30+2F)',
      },
      101: {
        conductors: '101/C',
        factor: 12,
        layUp: '2-8-14-20-26-(31+1F)',
      },
      102: {
        conductors: '102/C',
        factor: 12,
        layUp: '2-8-14-20-26-32',
      },
      103: {
        conductors: '103/C',
        factor: 12.15,
        layUp: '3-9-15-21-27-(28+5F)',
      },
      104: {
        conductors: '104/C',
        factor: 12.15,
        layUp: '3-9-15-21-27-(29+4F)',
      },
      105: {
        conductors: '105/C',
        factor: 12.15,
        layUp: '3-9-15-21-27-(30+3F)',
      },
      106: {
        conductors: '106/C',
        factor: 12.15,
        layUp: '3-9-15-21-27-(31+2F)',
      },
      107: {
        conductors: '107/C',
        factor: 12.15,
        layUp: '3-9-15-21-27-(32+1F)',
      },
      108: {
        conductors: '108/C',
        factor: 12.15,
        layUp: '3-9-15-21-27-33',
      },
      109: {
        conductors: '109/C',
        factor: 12.415,
        layUp: '4-10-16-22-28-(29+5F)',
      },
      110: {
        conductors: '110/C',
        factor: 12.415,
        layUp: '4-10-16-22-28-(30+4F)',
      },
      111: {
        conductors: '111/C',
        factor: 12.415,
        layUp: '4-10-16-22-28-(31-3F)',
      },
      112: {
        conductors: '112/C',
        factor: 12.415,
        layUp: '4-10-16-22-28-(32+2F)',
      },
      113: {
        conductors: '113/C',
        factor: 12.415,
        layUp: '4-10-16-22-28-(33+1F)',
      },
      114: {
        conductors: '114/C',
        factor: 12.415,
        layUp: '4-10-16-22-28-34',
      },
      115: {
        conductors: '115/C',
        factor: 12.7,
        layUp: 'F-5-11-17-23-29-(30+5F)',
      },
      116: {
        conductors: '116/C',
        factor: 12.7,
        layUp: 'F-5-11-17-23-29-(31+4F)',
      },
      117: {
        conductors: '117/C',
        factor: 12.7,
        layUp: 'F-5-11-17-23-29-(32+3F)',
      },
      118: {
        conductors: '118/C',
        factor: 12.7,
        layUp: 'F-5-11-17-23-29-(33+2F)',
      },
      119: {
        conductors: '119/C',
        factor: 12.7,
        layUp: 'F-5-11-17-23-29-(34+1F)',
      },
      120: {
        conductors: '120/C',
        factor: 12.7,
        layUp: 'F-5-11-17-23-29-35',
      },
      121: {
        conductors: '121/C',
        factor: 13,
        layUp: '1-6-12-18-24-30-(30+6F)',
      },
      122: {
        conductors: '122/C',
        factor: 13,
        layUp: '1-6-12-18-24-30-(31+5F)',
      },
      123: {
        conductors: '123/C',
        factor: 13,
        layUp: '1-6-12-18-24-30-(32+4F)',
      },
      124: {
        conductors: '124/C',
        factor: 13,
        layUp: '1-6-12-18-24-30-(33+3F)',
      },
      125: {
        conductors: '125/C',
        factor: 13,
        layUp: '1-6-12-18-24-30-(34+2F)',
      },
      126: {
        conductors: '126/C',
        factor: 13,
        layUp: '1-6-12-18-24-30-(35+1F)',
      },
      127: {
        conductors: '127/C',
        factor: 13,
        layUp: '1-6-12-18-24-30-36',
      },
      128: {
        conductors: '128/C',
        factor: 13.3,
        layUp: '(1+F)-7-13-19-25-31-(32+5F)',
      },
      129: {
        conductors: '129/C',
        factor: 13.3,
        layUp: '(1+F)-7-13-19-25-31-(33+4F)',
      },
      130: {
        conductors: '130/C',
        factor: 13.3,
        layUp: '(1+F)-7-13-19-25-31-(34+3F)',
      },
      131: {
        conductors: '131/C',
        factor: 13.3,
        layUp: '(1+F)-7-13-19-25-31-(35+2F)',
      },
      132: {
        conductors: '132/C',
        factor: 13.3,
        layUp: '(1+F)-7-13-19-25-31-(36+1F)',
      },
      133: {
        conductors: '133/C',
        factor: 13.3,
        layUp: '(1+F)-7-13-19-25-31-37',
      },
      134: {
        conductors: '134/C',
        factor: 14,
        layUp: '2-8-14-20-26-32-(32+6F)',
      },
      135: {
        conductors: '135/C',
        factor: 14,
        layUp: '2-8-14-20-26-32-(33+5F)',
      },
      136: {
        conductors: '136/C',
        factor: 14,
        layUp: '2-8-14-20-26-32-(34+4F)',
      },
      137: {
        conductors: '137/C',
        factor: 14,
        layUp: '2-8-14-20-26-32-(35+3F)',
      },
      138: {
        conductors: '138/C',
        factor: 14,
        layUp: '2-8-14-20-26-32-(36+2F)',
      },
      139: {
        conductors: '139/C',
        factor: 14,
        layUp: '2-8-14-20-26-32-(37+1F)',
      },
      140: {
        conductors: '140/C',
        factor: 14,
        layUp: '2-8-14-20-26-32-8',
      },
    },
  },
  compositeCable: {
    wireDiameter: 0.075,
    conductorQuantity: null,
    answer: null,
    factor: null,
    layUp: null,
    showPopup: false,
    numberOfTypes: 15,
  },
};
